import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';

interface DialogData {
  message: string;
  checkboxLabel: string;
}

/**
 * Confirmation Dialog Checkbox Component
 */
@Component({
  templateUrl: './confirmation_dialog_checkbox.ng.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, MatCheckboxModule, MatDialogModule],
})
export class ConfirmationDialogCheckbox {
  private readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<ConfirmationDialogCheckbox>);

  // Initialize properties from the injected data
  readonly message = this.data.message;
  readonly checkboxLabel = this.data.checkboxLabel;

  readonly isConfirmed = signal(false);

  onCheckboxChange(checked: boolean) {
    if (checked) {
      // Closes the dialog and returns 'true' to the service
      this.dialogRef.close(true);
    }
  }
}
